import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('PushList-index-1992f2b7f4ef25b82-1'),
    routerUrl: '/pushList',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./PushList')),
    children: [
      //$MORE$
    ],
  },
];
